// extracted by mini-css-extract-plugin
module.exports = {"main-container":"FootPrintListActionColumn_main-container__J0BXa","column-button":"FootPrintListActionColumn_column-button__G8oiG"};